import React from 'react';
import logo from '../images/Logo For Website 01.png';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="border-t border-zinc-200 py-12 mt-24">
    <div className="max-w-5xl mx-auto px-6">
      <div className="flex flex-col items-center gap-4">
        {/* Logo */}
        <img 
          src={logo}
          alt="Moinduel Logo"
          className="h-8 w-auto object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <span 
          className="font-bold text-xl text-zinc-900 hidden"
          style={{ display: 'none' }}
        >
          Moinduel
        </span>
        
        {/* Links */}
        <div className="flex gap-6 text-zinc-600">
          <a href="/privacy-policy" className="hover:text-orange-500 transition-colors">
            Privacy Policy
          </a>
          <a href="mailto:info@moinduel.com" className="hover:text-orange-500 transition-colors">
            info@moinduel.com
          </a>
        </div>

        {/* Copyright */}
        <div className="text-zinc-600">
          © 2024 Moinduel. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
);

const PrivacyPolicy = (onSignup) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="w-full px-4 sm:px-6 lg:px-8 sticky top-0 bg-white/80 backdrop-blur-sm z-50 border-b border-zinc-100">
        <div className="max-w-6xl mx-auto flex justify-between items-center py-4">
          <div className="flex items-center">
            {/* Logo with Link */}
            <Link to="/" className="flex items-center">
              <img 
                src={logo}
                alt="Moinduel Logo"
                className="h-8 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <span 
                className="font-bold text-xl text-zinc-900 hidden"
                style={{ display: 'none' }}
              >
                Moinduel
              </span>
            </Link>
          </div>
          <button 
            onClick={onSignup}
            className="px-6 py-2 rounded-full border border-zinc-200 hover:bg-zinc-50 hover:border-zinc-300 transition-colors"
          >
            Sign up
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-zinc-900 mb-8">Privacy Policy</h1>
        
        <div className="space-y-8 text-zinc-600">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">1. Introduction</h2>
            <p>
              At Moinduel, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI learning platform.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">2. Information We Collect</h2>
            <p>We collect information that you provide directly to us, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Account information (name, email, password)</li>
              <li>Profile information (educational background, preferences)</li>
              <li>Learning activity data</li>
              <li>Communication data (messages, feedback)</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">3. How We Use Your Information</h2>
            <p>We use the collected information for:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Providing and improving our educational services</li>
              <li>Personalizing learning experiences</li>
              <li>Communicating with users</li>
              <li>Analytics and platform optimization</li>
              <li>Legal compliance</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">4. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to maintain the security of your personal information, including encryption, access controls, and regular security assessments.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">5. Data Sharing and Disclosure</h2>
            <p>We may share your information with:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Service providers and partners who assist in platform operation</li>
              <li>Educational institutions (with consent)</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of certain data processing activities</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">7. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:{' '}
              <a href="mailto:infomoinduel@gmail.com" className="text-orange-500 hover:text-orange-600">
              infomoinduel@gmail.com
              </a>
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-zinc-900">8. Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date.
            </p>
            <p className="font-medium">
              Last updated: November 8, 2024
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;